import React from "react";
import * as ReactDOMServer from "react-dom/server";
import Leaflet from "leaflet";

import { invertColor } from "../utils/helpers";
import variableColors from "../_App.module.scss";
import { getHeadwayStatusColor } from "../utils/swiftlyHelpers";

const { appBackgroundColorWhiteSmoke, indigoColor, secondaryColor, primaryColor } = variableColors;

//* Render bus icon color
const getBusColor = (colorStatus?: string, addedStatus?: string): string => {
  const busFillColor: string =
    colorStatus === "lightgreen" || addedStatus === "busOnTime"
      ? "#008000" //* On time bus
      : colorStatus === "orangered" || addedStatus === "busTooFast"
      ? "#8B0000" //* Too fast bus
      : colorStatus === "yellow" || addedStatus === "delayedBus"
      ? "#F6BE00"
      : colorStatus === "" || addedStatus === "layoverBus"
      ? secondaryColor
      : //* Delayed bus
        "#000000"; //* Default color
  return busFillColor;
};

//* SVG BusAtStop Icon
const BusAtStop = (): JSX.Element => {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0.5 0.5 23 23"
      fill={appBackgroundColorWhiteSmoke}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M14 9V15M10 9V15M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
          stroke={indigoColor}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

//* SVG Bus Icon
const MapBusesIcon = ({
  colorStatus,
  addedStatus,
  isActive,
  isHeadwayIcon,
  headwayStatus,
}: {
  colorStatus?: string;
  addedStatus?: string;
  isActive?: boolean;
  isHeadwayIcon?: boolean;
  headwayStatus?: string;
}): JSX.Element => {
  return (
    <React.Fragment>
      <svg
        version="1.1"
        height="100%"
        width="100%"
        viewBox="1 1 20 20"
        fill="transparent"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.47046 17.0591L10.2111 5.57771C10.9482 4.10361 13.0518 4.10362 13.7889 5.57771L19.5295 17.0591C20.3661 18.7322 18.6528 20.5356 16.9391 19.7858L12.4008 17.8004C12.1453 17.6886 11.8547 17.6886 11.5992 17.8004L7.06094 19.7858C5.34719 20.5356 3.6339 18.7322 4.47046 17.0591Z"
          stroke={invertColor(
            isActive
              ? primaryColor
              : isHeadwayIcon && headwayStatus
              ? getHeadwayStatusColor(headwayStatus)
              : getBusColor(colorStatus, addedStatus)
          )}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          //* Active bus or other colors
          fill={
            isActive
              ? primaryColor
              : isHeadwayIcon && headwayStatus
              ? getHeadwayStatusColor(headwayStatus)
              : getBusColor(colorStatus, addedStatus)
          }
        ></path>
      </svg>
    </React.Fragment>
  );
};

//* Map Buses Icons Creator
const mapBusesIcons = (
  colorStatus?: string,
  addedStatus?: string,
  isAtStop?: boolean,
  isActive?: boolean,
  rotation?: number,
  isHeadwayIcon?: boolean,
  headwayStatus?: string
): Leaflet.DivIcon => {
  return Leaflet.divIcon({
    iconSize: isActive ? [36, 36] : [28, 28],
    iconAnchor: isActive ? [18, 18] : [14, 14],
    popupAnchor: isActive ? [0, -18] : [0, -14],
    tooltipAnchor: [0, 0],
    className: "bus_icon",
    html: ReactDOMServer.renderToString(
      <React.Fragment>
        <div
          style={{
            backgroundColor: "transparent",
            transform: !isAtStop ? `rotate(${rotation}deg)` : "",
          }}
        >
          {isAtStop ? (
            <BusAtStop />
          ) : (
            <MapBusesIcon
              colorStatus={colorStatus}
              addedStatus={addedStatus}
              isActive={isActive}
              isHeadwayIcon={isHeadwayIcon}
              headwayStatus={headwayStatus}
            />
          )}
        </div>
      </React.Fragment>
    ),
  });
};

export default mapBusesIcons;
